import { render, staticRenderFns } from "./Dispensa.vue?vue&type=template&id=00304195"
import script from "./Dispensa.vue?vue&type=script&lang=js"
export * from "./Dispensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports